import React, { useEffect, useMemo, useState } from 'react';
import { Groupper, Table, Header, Button } from 'react-frontier';
import { Link, useParams } from 'react-router-dom';
import { useTitle } from '../../Hooks';
import { JobDetails as D } from '../../Classes';
import { getPayRateTypeLocale } from '../../Util';
import { addCommas } from '@tempu/components/Util';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';
import { GoogleMap } from '../../components';

import remarkGfm from 'remark-gfm';
import moment from 'moment';
import API from '../../API';




var JobDetails = ()=>{
	var params = useParams<{ job_id: string }>();
	var job_id = parseInt(params?.job_id);
	var { setTitle } = useTitle();
	var [loadError, setLoadError] = useState<string>(null);
	var [details, setDetails] = useState<D>(null);

	useEffect(()=>{
		setTitle('Información de empleo');
		API.getJobDetails(job_id).then(res=>{
			if(res.error) return setLoadError(res.message);
			setDetails(res.data);
		}).catch(err=>{
			return setLoadError('Hubo un error inesperado obteniendo los detalles del puesto. (LCL-1)');
		})
	}, []);

	var maps_link = useMemo(()=>{
		if(!details || !details?.location) return null;
		if(details.location.place_id){
			return `https://www.google.com/maps/place/?q=place_id:${details.location.place_id}`;
		}else{
			return `https://www.google.com/maps?q=${details.location.lattitude},${details.location.longitude}`;
		}
	}, [details]);

	if(loadError){
		return <Header text='Error' subtext={loadError} />
	}

	if(!details) {
		return <Header loading text='Cargando datos' />;
	}
	
	return <div className='tp user_settings-screen'>
		<Groupper width={600} title={'Información de empleo'}>
			<Table 
				striped
				details
				data={[
					['Empleo', details.posting_name],
					['Empresa', details.business_name],
				]}
				style={{ marginTop: -20 }}
			/>
			<Groupper.Divider text={'Información de puesto'} style={{ marginTop: 0, fontSize: 16, fontWeight: 'bold' }}/>
			<Table 
				striped
				details
				data={[
					['Puesto', details.job_name],
					['Sueldo', <>
						<b>${addCommas(details.pay_rate)}</b> · {getPayRateTypeLocale(details.rate_type)}
					</>],
					['Fecha inicio', moment.unix(details.date_start).format('DD/MMM/YY HH:mm')],
					['Fecha fin', moment.unix(details.date_end).format('DD/MMM/YY HH:mm')],
				]}
				style={{ marginTop: -20 }}
			/>
			{details.instructions ? <>
				<Groupper.Divider text={'Instrucciones'} style={{ marginTop: 0, fontSize: 16, fontWeight: 'bold' }}/>
				<ReactMarkdown linkTarget={'_blank'} remarkPlugins={[remarkGfm]} children={details.instructions} />
			</> : null}
			<Groupper.Divider text={'Ubicación'} style={{ marginTop: 0, fontSize: 16, fontWeight: 'bold' }}/>
			{details && details.location ? <>
				<GoogleMap className="map-embed" location={details.location} height={300} />
				{!!maps_link && (
					<div style={{ textAlign: 'center' }}>
						<Button text='Abrir Google Maps' color='black' iconName='map' as={Link} to={maps_link} target='blank' style={{ marginTop: 10}}/>
					</div>
				)}
			</> : (
				<div className='no-info'>Este empleo no cuenta con ubicación registrada</div>
			)}
		</Groupper>
	</div>
}

export default JobDetails;